/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { historyAdminControllerBulkSaveV1 } from '../fn/history-admin/history-admin-controller-bulk-save-v-1';
import { HistoryAdminControllerBulkSaveV1$Params } from '../fn/history-admin/history-admin-controller-bulk-save-v-1';
import { historyAdminControllerCreateV1 } from '../fn/history-admin/history-admin-controller-create-v-1';
import { HistoryAdminControllerCreateV1$Params } from '../fn/history-admin/history-admin-controller-create-v-1';
import { historyAdminControllerDeleteV1 } from '../fn/history-admin/history-admin-controller-delete-v-1';
import { HistoryAdminControllerDeleteV1$Params } from '../fn/history-admin/history-admin-controller-delete-v-1';
import { historyAdminControllerFindAllV1 } from '../fn/history-admin/history-admin-controller-find-all-v-1';
import { HistoryAdminControllerFindAllV1$Params } from '../fn/history-admin/history-admin-controller-find-all-v-1';
import { historyAdminControllerFindByIdV1 } from '../fn/history-admin/history-admin-controller-find-by-id-v-1';
import { HistoryAdminControllerFindByIdV1$Params } from '../fn/history-admin/history-admin-controller-find-by-id-v-1';
import { historyAdminControllerReorderV1 } from '../fn/history-admin/history-admin-controller-reorder-v-1';
import { HistoryAdminControllerReorderV1$Params } from '../fn/history-admin/history-admin-controller-reorder-v-1';
import { historyAdminControllerSearchV1 } from '../fn/history-admin/history-admin-controller-search-v-1';
import { HistoryAdminControllerSearchV1$Params } from '../fn/history-admin/history-admin-controller-search-v-1';
import { historyAdminControllerToggleExposedV1 } from '../fn/history-admin/history-admin-controller-toggle-exposed-v-1';
import { HistoryAdminControllerToggleExposedV1$Params } from '../fn/history-admin/history-admin-controller-toggle-exposed-v-1';
import { historyAdminControllerUpdateV1 } from '../fn/history-admin/history-admin-controller-update-v-1';
import { HistoryAdminControllerUpdateV1$Params } from '../fn/history-admin/history-admin-controller-update-v-1';
import { HistoryDto } from '../models/history-dto';
import { PageInfoDto } from '../models/page-info-dto';

@Injectable({ providedIn: 'root' })
export class HistoryAdminService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `historyAdminControllerSearchV1()` */
  static readonly HistoryAdminControllerSearchV1Path = '/api/v1/histories/admin/search';

  /**
   * History 검색 (관리자).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `historyAdminControllerSearchV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  historyAdminControllerSearchV1$Response(params: HistoryAdminControllerSearchV1$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'items': Array<HistoryDto>;
'pageInfo': PageInfoDto;
}>> {
    const obs = historyAdminControllerSearchV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * History 검색 (관리자).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `historyAdminControllerSearchV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  historyAdminControllerSearchV1(params: HistoryAdminControllerSearchV1$Params, context?: HttpContext): Observable<{
'items': Array<HistoryDto>;
'pageInfo': PageInfoDto;
}> {
    const resp = this.historyAdminControllerSearchV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{
'items': Array<HistoryDto>;
'pageInfo': PageInfoDto;
}>): {
'items': Array<HistoryDto>;
'pageInfo': PageInfoDto;
} => r.body)
    );
  }

  /** Path part for operation `historyAdminControllerFindAllV1()` */
  static readonly HistoryAdminControllerFindAllV1Path = '/api/v1/histories/admin/all';

  /**
   * 모든 History 목록 조회 (관리자).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `historyAdminControllerFindAllV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  historyAdminControllerFindAllV1$Response(params?: HistoryAdminControllerFindAllV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<HistoryDto>>> {
    const obs = historyAdminControllerFindAllV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 모든 History 목록 조회 (관리자).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `historyAdminControllerFindAllV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  historyAdminControllerFindAllV1(params?: HistoryAdminControllerFindAllV1$Params, context?: HttpContext): Observable<Array<HistoryDto>> {
    const resp = this.historyAdminControllerFindAllV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<HistoryDto>>): Array<HistoryDto> => r.body)
    );
  }

  /** Path part for operation `historyAdminControllerFindByIdV1()` */
  static readonly HistoryAdminControllerFindByIdV1Path = '/api/v1/histories/admin/{id}';

  /**
   * History id로 조회 (관리자).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `historyAdminControllerFindByIdV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  historyAdminControllerFindByIdV1$Response(params: HistoryAdminControllerFindByIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<HistoryDto>> {
    const obs = historyAdminControllerFindByIdV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * History id로 조회 (관리자).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `historyAdminControllerFindByIdV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  historyAdminControllerFindByIdV1(params: HistoryAdminControllerFindByIdV1$Params, context?: HttpContext): Observable<HistoryDto> {
    const resp = this.historyAdminControllerFindByIdV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<HistoryDto>): HistoryDto => r.body)
    );
  }

  /** Path part for operation `historyAdminControllerDeleteV1()` */
  static readonly HistoryAdminControllerDeleteV1Path = '/api/v1/histories/admin/{id}';

  /**
   * History 삭제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `historyAdminControllerDeleteV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  historyAdminControllerDeleteV1$Response(params: HistoryAdminControllerDeleteV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    const obs = historyAdminControllerDeleteV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * History 삭제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `historyAdminControllerDeleteV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  historyAdminControllerDeleteV1(params: HistoryAdminControllerDeleteV1$Params, context?: HttpContext): Observable<boolean> {
    const resp = this.historyAdminControllerDeleteV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `historyAdminControllerUpdateV1()` */
  static readonly HistoryAdminControllerUpdateV1Path = '/api/v1/histories/admin/{id}';

  /**
   * History 수정.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `historyAdminControllerUpdateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  historyAdminControllerUpdateV1$Response(params: HistoryAdminControllerUpdateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<HistoryDto>> {
    const obs = historyAdminControllerUpdateV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * History 수정.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `historyAdminControllerUpdateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  historyAdminControllerUpdateV1(params: HistoryAdminControllerUpdateV1$Params, context?: HttpContext): Observable<HistoryDto> {
    const resp = this.historyAdminControllerUpdateV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<HistoryDto>): HistoryDto => r.body)
    );
  }

  /** Path part for operation `historyAdminControllerCreateV1()` */
  static readonly HistoryAdminControllerCreateV1Path = '/api/v1/histories/admin';

  /**
   * History 생성.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `historyAdminControllerCreateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  historyAdminControllerCreateV1$Response(params: HistoryAdminControllerCreateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<HistoryDto>> {
    const obs = historyAdminControllerCreateV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * History 생성.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `historyAdminControllerCreateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  historyAdminControllerCreateV1(params: HistoryAdminControllerCreateV1$Params, context?: HttpContext): Observable<HistoryDto> {
    const resp = this.historyAdminControllerCreateV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<HistoryDto>): HistoryDto => r.body)
    );
  }

  /** Path part for operation `historyAdminControllerBulkSaveV1()` */
  static readonly HistoryAdminControllerBulkSaveV1Path = '/api/v1/histories/admin/bulk-save';

  /**
   * 연혁 일괄 저장 (Create/Update/Delete).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `historyAdminControllerBulkSaveV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  historyAdminControllerBulkSaveV1$Response(params: HistoryAdminControllerBulkSaveV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    const obs = historyAdminControllerBulkSaveV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 연혁 일괄 저장 (Create/Update/Delete).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `historyAdminControllerBulkSaveV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  historyAdminControllerBulkSaveV1(params: HistoryAdminControllerBulkSaveV1$Params, context?: HttpContext): Observable<boolean> {
    const resp = this.historyAdminControllerBulkSaveV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `historyAdminControllerReorderV1()` */
  static readonly HistoryAdminControllerReorderV1Path = '/api/v1/histories/admin/reorder';

  /**
   * 연혁 순서 변경.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `historyAdminControllerReorderV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  historyAdminControllerReorderV1$Response(params: HistoryAdminControllerReorderV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    const obs = historyAdminControllerReorderV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 연혁 순서 변경.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `historyAdminControllerReorderV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  historyAdminControllerReorderV1(params: HistoryAdminControllerReorderV1$Params, context?: HttpContext): Observable<boolean> {
    const resp = this.historyAdminControllerReorderV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `historyAdminControllerToggleExposedV1()` */
  static readonly HistoryAdminControllerToggleExposedV1Path = '/api/v1/histories/admin/{id}/toggle-exposed';

  /**
   * History 노출 여부 토글.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `historyAdminControllerToggleExposedV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  historyAdminControllerToggleExposedV1$Response(params: HistoryAdminControllerToggleExposedV1$Params, context?: HttpContext): Observable<StrictHttpResponse<HistoryDto>> {
    const obs = historyAdminControllerToggleExposedV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * History 노출 여부 토글.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `historyAdminControllerToggleExposedV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  historyAdminControllerToggleExposedV1(params: HistoryAdminControllerToggleExposedV1$Params, context?: HttpContext): Observable<HistoryDto> {
    const resp = this.historyAdminControllerToggleExposedV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<HistoryDto>): HistoryDto => r.body)
    );
  }

}
